import { findAll, isUnattached, setAttached } from "./dom";

const showLineHeader = () => {
  const header = document.getElementById("invoice-line-header");
  if (!header) return;
  const visibleLines = findAll(document, ".invoice-line-item").filter(
    (el) => el.style.display !== "none"
  );
  header.classList.toggle("d-none", visibleLines.length === 0);
};

let catalogCache = null;
const getCatalog = () => {
  if (catalogCache) return catalogCache;
  const node = document.getElementById("invoice-catalog-data");
  if (!node) return [];
  try {
    catalogCache = JSON.parse(node.textContent);
  } catch (e) {
    catalogCache = [];
  }
  return catalogCache;
};

const handleDescriptionPick = (descInput) => {
  const value = descInput.value.trim();
  if (!value) return;
  const match = getCatalog().find((item) => item.label === value);
  if (!match) return;
  const row = descInput.closest(".invoice-line-item");
  if (!row) return;
  const priceInput = row.querySelector("input[name*='[unit_price_dkk]']");
  if (priceInput && (priceInput.value === "" || parseFloat(priceInput.value) === 0)) {
    priceInput.value = match.price.toFixed(2);
  }
};

const attachDescriptionHandlers = () => {
  findAll(document, ".gk-invoice-description")
    .filter((el) => isUnattached("invoice-desc", el))
    .map((el) => setAttached("invoice-desc", el))
    .forEach((el) => el.addEventListener("change", () => handleDescriptionPick(el)));
};

const removeLineItem = (btn) => {
  const row = btn.closest(".invoice-line-item");
  if (!row) return;
  const destroyInput = row.querySelector(".gk-line-destroy");
  if (destroyInput) {
    destroyInput.value = "true";
    row.style.display = "none";
  } else {
    row.remove();
  }
  showLineHeader();
};

const attachRemoveLineHandlers = () => {
  findAll(document, ".gk-remove-line")
    .filter((el) => isUnattached("invoice-remove-line", el))
    .map((el) => setAttached("invoice-remove-line", el))
    .forEach((el) =>
      el.addEventListener("click", (e) => {
        e.preventDefault();
        removeLineItem(el);
      })
    );
};

const addLineItem = () => {
  const template = document.getElementById("invoice-line-template");
  const container = document.getElementById("invoice-line-items");
  if (!template || !container) return null;

  const time = Date.now();
  const html = template.innerHTML.replace(/NEW_RECORD/g, time);
  const wrapper = document.createElement("div");
  wrapper.innerHTML = html.trim();
  const node = wrapper.firstElementChild;
  if (!node) return null;
  container.appendChild(node);
  attachDescriptionHandlers();
  attachRemoveLineHandlers();
  showLineHeader();
  return node;
};

const addLineFromCatalog = (name, price) => {
  const node = addLineItem();
  if (!node) return;
  const descInput = node.querySelector("input[name*='[description]']");
  const priceInput = node.querySelector("input[name*='[unit_price_dkk]']");
  if (descInput) descInput.value = name || "";
  if (priceInput) priceInput.value = price || "";
};

const attachCatalogPickerHandler = () => {
  findAll(document, "#invoice-catalog-picker")
    .filter((el) => isUnattached("invoice-catalog-picker", el))
    .map((el) => setAttached("invoice-catalog-picker", el))
    .forEach((select) =>
      select.addEventListener("change", () => {
        const opt = select.options[select.selectedIndex];
        if (!opt || !opt.value) return;
        const name = opt.value;
        const price = opt.getAttribute("data-price") || "";
        addLineFromCatalog(name, price);
        select.selectedIndex = 0;
      })
    );
};

const addPriceEntry = () => {
  const template = document.getElementById("price-entry-template");
  const container = document.getElementById("custom-product-prices");
  if (!template || !container) return;

  const time = Date.now();
  const html = template.innerHTML.replace(/NEW_RECORD/g, time);
  const wrapper = document.createElement("div");
  wrapper.innerHTML = html.trim();
  const node = wrapper.firstElementChild;
  if (!node) return;
  container.appendChild(node);
  const header = document.getElementById("custom-product-prices-header");
  if (header) header.classList.remove("d-none");
  attachRemovePriceHandlers();
};

const removePriceEntry = (btn) => {
  const row = btn.closest(".custom-price-entry");
  if (!row) return;
  const destroyInput = row.querySelector(".gk-price-destroy");
  if (destroyInput) {
    destroyInput.value = "true";
    row.style.display = "none";
  } else {
    row.remove();
  }
};

const attachRemovePriceHandlers = () => {
  findAll(document, ".gk-remove-price")
    .filter((el) => isUnattached("price-remove", el))
    .map((el) => setAttached("price-remove", el))
    .forEach((el) =>
      el.addEventListener("click", (e) => {
        e.preventDefault();
        removePriceEntry(el);
      })
    );
};

const addProductPriceEntry = () => {
  const template = document.getElementById("product-price-entry-template");
  const container = document.getElementById("product-prices");
  if (!template || !container) return;

  const time = Date.now();
  const html = template.innerHTML.replace(/NEW_RECORD/g, time);
  const wrapper = document.createElement("div");
  wrapper.innerHTML = html.trim();
  const node = wrapper.firstElementChild;
  if (!node) return;
  container.appendChild(node);
  const header = document.getElementById("product-prices-header");
  if (header) header.classList.remove("d-none");
  attachRemoveProductPriceHandlers();
};

const removeProductPriceEntry = (btn) => {
  const row = btn.closest(".product-price-entry");
  if (!row) return;
  const destroyInput = row.querySelector(".gk-product-price-destroy");
  if (destroyInput) {
    destroyInput.value = "true";
    row.style.display = "none";
  } else {
    row.remove();
  }
};

const attachRemoveProductPriceHandlers = () => {
  findAll(document, ".gk-remove-product-price")
    .filter((el) => isUnattached("product-price-remove", el))
    .map((el) => setAttached("product-price-remove", el))
    .forEach((el) =>
      el.addEventListener("click", (e) => {
        e.preventDefault();
        removeProductPriceEntry(el);
      })
    );
};

export default () => {
  catalogCache = null;

  findAll(document, "#add-invoice-line")
    .filter((el) => isUnattached("invoice-add", el))
    .map((el) => setAttached("invoice-add", el))
    .forEach((el) =>
      el.addEventListener("click", (e) => {
        e.preventDefault();
        addLineItem();
      })
    );

  attachCatalogPickerHandler();
  attachDescriptionHandlers();
  attachRemoveLineHandlers();

  findAll(document, "#add-price-entry")
    .filter((el) => isUnattached("price-add", el))
    .map((el) => setAttached("price-add", el))
    .forEach((el) =>
      el.addEventListener("click", (e) => {
        e.preventDefault();
        addPriceEntry();
      })
    );

  attachRemovePriceHandlers();

  findAll(document, "#add-product-price-entry")
    .filter((el) => isUnattached("product-price-add", el))
    .map((el) => setAttached("product-price-add", el))
    .forEach((el) =>
      el.addEventListener("click", (e) => {
        e.preventDefault();
        addProductPriceEntry();
      })
    );

  attachRemoveProductPriceHandlers();

  findAll(document, "#invoice-source-tabs .nav-link")
    .filter((el) => isUnattached("invoice-source-tab", el))
    .map((el) => setAttached("invoice-source-tab", el))
    .forEach((el) =>
      el.addEventListener("click", (e) => {
        e.preventDefault();
        if (el.disabled) return;
        const target = el.dataset.pane;
        findAll(document, "#invoice-source-tabs .nav-link").forEach((t) =>
          t.classList.toggle("active", t === el)
        );
        findAll(document, ".gk-invoice-source-pane").forEach((p) =>
          p.classList.toggle("d-none", p.dataset.pane !== target)
        );
      })
    );

  findAll(document, "#invoice-aftale-client-filter")
    .filter((el) => isUnattached("aftale-client-filter", el))
    .map((el) => setAttached("aftale-client-filter", el))
    .forEach((sel) => {
      sel.addEventListener("change", () => {
        const aftaleSel = document.getElementById("invoice-aftale-select");
        const dataNode = document.getElementById("invoice-aftale-data");
        if (!aftaleSel || !dataNode) return;
        let appointments = [];
        try { appointments = JSON.parse(dataNode.textContent); } catch (e) {}
        const clientId = sel.value;
        while (aftaleSel.options.length > 0) aftaleSel.remove(0);
        const placeholder = document.createElement("option");
        placeholder.value = "";
        placeholder.textContent = clientId ? "— Vælg aftale —" : "— Vælg klient først —";
        aftaleSel.appendChild(placeholder);
        if (clientId) {
          appointments
            .filter((a) => a.client_id === clientId)
            .forEach((a) => {
              const o = document.createElement("option");
              o.value = a.id;
              o.textContent = a.label;
              aftaleSel.appendChild(o);
            });
          aftaleSel.disabled = false;
        } else {
          aftaleSel.disabled = true;
        }
      });
    });

  findAll(document, "#invoice_due_date")
    .filter((el) => isUnattached("invoice-due-date-hint", el))
    .map((el) => setAttached("invoice-due-date-hint", el))
    .forEach((input) => {
      input.addEventListener("input", () => {
        const hint = document.getElementById("invoice-due-date-hint");
        if (!hint || !input.value) return;
        const today = new Date(hint.dataset.today + "T00:00:00");
        const chosen = new Date(input.value + "T00:00:00");
        const diff = Math.round((chosen - today) / 86400000);
        const defaultDays = parseInt(hint.dataset.defaultDays, 10);
        const dateText = chosen.toLocaleDateString("da-DK", { day: "numeric", month: "long", year: "numeric" });
        if (diff === defaultDays) {
          hint.textContent = `Standard: ${defaultDays} dage (${dateText})`;
        } else {
          hint.textContent = `${diff} dage (${dateText})`;
        }
      });
    });

  showLineHeader();
};
